import React from "react";
import './fun.css';

class FunFact extends React.Component {

    render() {
        return (
            <div className="funy">
                <div>Fun Fact Loading Infinitely !!!</div>
                {/* <div>fun fact 2</div> */}
                {/* <div>fun fact 3</div>
                <div>fun fact 4</div>
                <div>fun fact 5</div>
                <div>fun fact 6</div>

                <div className="placing"></div> */}
            </div>
        )
    }
}

export default FunFact